<div class="modal-header">
  <h4 class="modal-title">
    Add Document
    <span class="collection-tag">{{ collectionName }}</span>
  </h4>
  <button 
    type="button" 
    class="custom-close-btn" 
    (click)="onCancel()" 
    [disabled]="isUploading"
    aria-label="Close">
    <img src="assets/icons/close-icon.svg" alt="close">
  </button>
</div>

<div class="modal-body">
  <p class="modal-description">
    Add a document to enhance the knowledge base of this collection.
  </p>

 <div class="form-group">
  <label for="documentName" class="form-label">Document Name</label>
  <input 
    type="text" 
    id="documentName"
    class="form-control" 
    [(ngModel)]="documentName"
    (ngModelChange)="onDocumentNameChange($event)"
    [placeholder]="selectedFiles.length > 1 ? 'File names will be used automatically' : 'Add Document Name'"
    [disabled]="isUploading"
    [readonly]="isReadOnly || selectedFiles.length > 1"
  >
  <small class="hint-text" *ngIf="selectedFiles.length > 1">
    Multiple files selected. Each document name will use the file name.
  </small>
</div>

  <div class="form-group">
    <label for="documentCategory" class="form-label">Document Category</label>
    <select
      id="documentCategory"
      class="form-control form-select"
      [ngModel]="selectedCategory"
      (ngModelChange)="onCategoryChange($event)"
      [disabled]="isUploading">
      <option value="" disabled [selected]="!selectedCategory">Select Document Category</option>
      <option *ngFor="let category of getDropdownCategories()" [value]="category">{{ category }}</option>
      <option value="__add_new__">+ Add New Category</option>
    </select>
  </div>

  <div class="form-group" *ngIf="isAddingNewCategory">
    <label for="newCategoryName" class="form-label">New Category Name</label>
    <input
      type="text"
      id="newCategoryName"
      class="form-control"
      [(ngModel)]="newCategoryName"
      placeholder="Enter new category"
      [disabled]="isUploading">
  </div>


  <div *ngIf="selectedFiles.length === 0" class="upload-area" 
       [class.drag-over]="dragOver"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       (click)="fileInput.click()">
    <div class="upload-content">
      <div class="upload-text">Browse your file to upload!</div>
      <!-- <div class="upload-format">Supported formats: .docx, .pdf</div> -->
       <div class="upload-format">Supported formats: {{ getSupportedFormatsText() }}</div>
      <button type="button" class="browse-btn">
        Browse File
        <img src="assets/icons/doc-upload-btn.svg" alt="close">
      </button>
    </div>
    <input 
      #fileInput
      type="file" 
      [multiple]="!isReadOnly"
      [attr.accept]="getAcceptedFileTypes()"
      (change)="onFileSelected($event)"
      style="display: none;"
    >
  </div>

  <div class="selected-files" *ngIf="selectedFiles.length > 0">
    <div class="selected-files-header">
      <span>{{ selectedFiles.length }} file(s) selected</span>
      <span>{{ totalSelectedSize }}</span>
    </div>
    <div class="selected-files-list">
      <div class="selected-file-row" *ngFor="let file of selectedFiles">
        <span class="selected-file-name" [title]="file.name">{{ file.name }}</span>
        <div class="selected-file-meta">
          <span class="selected-file-size">{{ getFileSize(file) }}</span>
          <button type="button" class="remove-file-btn" (click)="removeSelectedFile(file)" [disabled]="isUploading" aria-label="Remove file">×</button>
        </div>
      </div>
    </div>
  </div>

  <app-file-upload-progress
    *ngIf="selectedFiles.length === 1 && !isUploading"
    [fileName]="selectedFiles[0].name"
    [fileSize]="firstSelectedFileSize"
    [progress]="100"
    [isUploading]="false"
    (cancelUpload)="onCancelUpload()">
  </app-file-upload-progress>

  <app-file-upload-progress
    *ngIf="selectedFiles.length === 1 && isUploading"
    [fileName]="selectedFiles[0].name"
    [fileSize]="firstSelectedFileSize"
    [progress]="50"
    [isUploading]="true"
    (cancelUpload)="onCancelUpload()">
  </app-file-upload-progress>

  <div class="batch-uploading-note" *ngIf="selectedFiles.length > 1 && isUploading">
    Files are queued. Upload starts right after you click Add.
  </div>
</div>

<div class="modal-footer">
  <button 
    type="button" 
    class="btn btn-cancel" 
    (click)="onCancel()"
    [disabled]="isUploading">
    Cancel
  </button>
  <button 
    type="button" 
    class="btn btn-upload" 
    (click)="onUpload()"
    [disabled]="(selectedFiles.length === 1 && !documentName.trim()) || selectedFiles.length === 0 || !selectedCategory || (isAddingNewCategory && !newCategoryName.trim()) || isUploading">
    {{ isUploading ? 'Adding...' : ' Add ' }}
  </button>
</div>
